/* Copyright 2013 - 2024 Waiterio LLC */
import getBaseUrl from '../getBaseUrl.js'

export default function fetchVersion() {
  return fetch(`${getBaseUrl()}/version.txt`).then(response =>
    response.ok ? response.text() : null,
  )
}
